import { useEffect, useState } from 'react'

import { Segment, Input, Icon, Grid, Loader, Button } from 'semantic-ui-react'
import { getTiposServicio, deleteTipoServicioLizen } from '../../../../api/Lizen/tipoServicio';
import { ModalBasic, PaginationTable } from '../../../../components/Common';
import { useHistory } from "react-router-dom";
import { ListadoTiposServicio } from '../../../../components/Admin/Lizen/ListadoTiposServicio';
import { HeaderPage } from '../../../../components/Admin';
import { toast } from 'react-toastify'
import "./AbmAdmin.scss"
import { getPermissions } from '../../../../components/Common';
import { useAuth } from '../../../../hooks';
import { animateScroll as scroll } from 'react-scroll'

const SEARCH_KEY = 'lizen_tipos_servicio_search'

export function TipoServicioLizenList() {
	const {auth} = useAuth()
	const [tiposServicio, setTiposServicio] = useState([])
	const [loading, setLoading] = useState(true)
	const [showModal, setShowModal] = useState(false)
	const [titleModal, setTitleModal] = useState(null)
	const [dataModal, setDataModal] = useState(null)
	const [contentModal, setContentModal] = useState(null)
	const [refetch, setRefetch] = useState(false)
	const [activePage, setActivePage] = useState(1);
	const [countPage, setCountPage] = useState(1);
	const [searchActive, setSearchActive] = useState("");

	const limitPagination = 10
	const history = useHistory()
	// Un usuario sin convenio (admin/CEO) ve de qué convenio es cada tipo.
	const mostrarConvenio = !auth?.me?.aseguradora

	const fetchTiposServicio = async (request = null) => {
		const data = await getTiposServicio(request)
		setTiposServicio(data?.results || [])
		setCountPage(data?.count || 0)
		setLoading(false)
	}

	useEffect(() => {
		scroll.scrollToTop();
		let searchExistentes = sessionStorage.getItem(SEARCH_KEY);
		if (searchExistentes) {
			setSearchActive(searchExistentes);
			fetchTiposServicio(`page=1&search=${searchExistentes}`);
		} else {
			fetchTiposServicio(`page=1`);
		}
	}, [refetch])

	const onRefetch = () => setRefetch((prev) => !prev);
	const openCloseModal = () => {
		setShowModal((prev) => !prev)
	}
	const onDeleteTipoServicio = async (tipoServicio) => {
		setContentModal(<p>Desea eliminar el tipo de servicio {tipoServicio.codigo} - {tipoServicio.nombre}?</p>)
		setTitleModal("Eliminar tipo de servicio")
		setShowModal(true)
		setDataModal(tipoServicio.id)
	}
	const openConfirmModal = async (id) => {
		try {
			let response = await deleteTipoServicioLizen(id)
			toast.success(response.data)
			setShowModal(false)
			onRefetch()
		} catch (error) {
			// El back rechaza con 400 si está en uso y con 403 si es global.
			toast.error(error.message)
			setShowModal(false)
		}
	}
	const crearTipoServicio = () => {
		history.push(`/admin/tipo_servicio_lizen/crear`);
	}
	const onEditTipoServicio = (tipoServicio) => {
		history.push(`/admin/tipo_servicio_lizen/edit/id/${tipoServicio.id}`);
	}
	const onShowTipoServicio = (tipoServicio) => {
		history.push(`/admin/tipo_servicio_lizen/show/id/${tipoServicio.id}`);
	}

	const onSearch = (e) => {
		const value = e.target.value;
		setSearchActive(value);
		sessionStorage.setItem(SEARCH_KEY, value);
		fetchTiposServicio(`page=1&search=${value}`);
		setActivePage(1);
	}
	const onChange = (e, pageInfo) => {
		let request = `page=${pageInfo.activePage.toString()}`;
		if (searchActive !== "") request += `&search=${searchActive}`;
		fetchTiposServicio(request);
		setActivePage(pageInfo.activePage);
	};

	return (
		<div>
			<HeaderPage title="Tipos de servicio" btnTitle="Agregar tipo de servicio" btnClick={crearTipoServicio} permitionName="add_tiposervicio" />

			<Grid as={Segment} className='segment_search'>
				<Grid.Row>
					<Grid.Column computer={3} mobile={16} tablet={16}>
						<Input
							fluid
							icon={<Icon name='search' className='color_search' inverted circular />}
							className="input_search"
							inverted
							placeholder='Buscar...'
							value={searchActive}
							onChange={onSearch}
						/>
					</Grid.Column>
					<Grid.Column computer={11} mobile={16} tablet={16}>
					</Grid.Column>
					<br></br>
					<Grid.Column computer={2} mobile={16} tablet={16}>
						{getPermissions("add_tiposervicio", auth) && (
							<Button circular basic positive onClick={crearTipoServicio}>
								Agregar tipo de servicio
							</Button>
						)}
					</Grid.Column>
				</Grid.Row>
			</Grid>

			{loading ? (
				<Loader active inline="centered">
					Cargando...
				</Loader>
			) : (
				<ListadoTiposServicio
					tiposServicio={tiposServicio}
					mostrarConvenio={mostrarConvenio}
					onDeleteTipoServicio={onDeleteTipoServicio}
					onEditTipoServicio={onEditTipoServicio}
					onShowTipoServicio={onShowTipoServicio}
					countPage={countPage}
					pagination={<PaginationTable
						onChange={onChange}
						activePage={activePage}
						countPage={countPage}
						limitPagination={limitPagination}
					/>}
				/>
			)}

			<ModalBasic
				show={showModal}
				size="small"
				title={titleModal}
				children={contentModal}
				onClose={openCloseModal}
				onConfirm={openConfirmModal}
				dataModal={dataModal}
			/>
		</div>
	)
}
